import { render, staticRenderFns } from "./GradeFeeDetail.vue?vue&type=template&id=19825422"
import script from "../../../controllers/custom/grade_fee/grade-fee-detail.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/grade_fee/grade-fee-detail.js?vue&type=script&lang=js&external"
import style0 from "./GradeFeeDetail.vue?vue&type=style&index=0&id=19825422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports